/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-11-09T18:45:59.606
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listReportRentContractRequestRelet,
	listReportRentContractRequestReletInit,
	listReportRentContractRequestReletByAuthorizations,
	deleteReportRentContractRequestRelet
	
} from '@api/report/ReportRentContractRequestRelet';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listReportRentContractRequestRelet({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContractRequestRelet(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportRentContractRequestReletByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContractRequestReletByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listReportRentContractRequestReletInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listReportRentContractRequestReletInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteReportRentContractRequestRelet({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteReportRentContractRequestRelet({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
